module.exports = __webpack_public_path__ + "img/3.41f53f95.png";